import type { SvgIconComponent } from '@mui/icons-material';
import AccountTree from '@mui/icons-material/AccountTree';
import Add from '@mui/icons-material/Add';
import Calculate from '@mui/icons-material/Calculate';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import CheckCircle from '@mui/icons-material/CheckCircle';
import ChecklistIcon from '@mui/icons-material/Checklist';
import CloseFullscreen from '@mui/icons-material/CloseFullscreen';
import Dashboard from '@mui/icons-material/Dashboard';
import Description from '@mui/icons-material/Description';
import Documents from '@mui/icons-material/Description';
import Edit from '@mui/icons-material/Edit';
import ErrorIcon from '@mui/icons-material/Error';
import Folder from '@mui/icons-material/Folder';
import History from '@mui/icons-material/History';
import Info from '@mui/icons-material/Info';
import InsightsIcon from '@mui/icons-material/Insights';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import ManageSearch from '@mui/icons-material/ManageSearch';
import Payment from '@mui/icons-material/Payment';
import Person from '@mui/icons-material/Person';
import ReceiptLong from '@mui/icons-material/ReceiptLong';
import TuneIcon from '@mui/icons-material/Tune';
import WarningAmber from '@mui/icons-material/WarningAmber';

export type PageHeaderIconVariant =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'success'
  | 'warning'
  | 'info'
  | 'inherit'
  | 'outlined';

export const PAGE_HEADER_ICONS = {
  invoice: ReceiptLong,
  documents: Documents,
  dashboard: Dashboard,
  calendar: CalendarMonth,
  search: ManageSearch,
  accountTree: AccountTree,
  calculate: Calculate,
  folder: Folder,
  description: Description,
  error: ErrorIcon,
  person: Person,
  info: Info,
  add: Add,
  edit: Edit,
  history: History,
  payment: Payment,
  insights: InsightsIcon,
  crossInvoice: CloseFullscreen,
  extension: KeyboardTabIcon,
  parameters: TuneIcon,
  checklist: ChecklistIcon,
  success: CheckCircle,
  warning: WarningAmber,
} as const;

export type PageHeaderIconType = keyof typeof PAGE_HEADER_ICONS;

export function getPageHeaderIconComponent(
  type: PageHeaderIconType,
): SvgIconComponent {
  return PAGE_HEADER_ICONS[type];
}
